<template>
<div  id="home" style="overflow-x: hidden">
  <router-view/>
</div>
</template>

<style>

</style>
